import Axios from "axios";
import { useEffect, useReducer } from "react";
import { dataFetchReducer } from "./utils/dataFetchReducer";
import { parseCalendarData } from "./parseCalendarData";
import { getConfiguration } from './utils/configuration';
import { getTimezoneOffset } from './utils/getTimezoneOffset';
import { systemCode, xs_languageCode } from '../.';

export function useFetchCalendarData(currentDate) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        let didCancel = false;
    
        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };
    
        const url = getConfiguration().api.getCalendario;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            day: currentDate,
            timezone: getTimezoneOffset()
        };
        fetchData(url, params, function(response) {
            const data = parseCalendarData(response, currentDate);
            
            dispatch({ type: 'FETCH_SUCCESS', payload: data });
        });
        
        return () => {
            didCancel = true;
        };
    }, [currentDate]);

    return [state, dispatch];
}
